function Footer() {
  return (
    <footer className="bg-gray-100 text-center py-4 mt-12">
      <p className="text-sm text-gray-400">&copy; 2026 Shopkart. All rights reserved.</p>
    </footer>
  )
}

export default Footer
